import React, { useState, useEffect, useRef } from 'react'
import Card from '../../components/destination_page/overview/Card'
import ImageBlock from '../../components/destination_page/overview/ImageBlock'
import SummaryPanel from '../../components/destination_page/overview/SummaryPanel'
import '../../styles/pages/DestinationPage/OverviewSection.css'

const DEFAULT_IMG_URL = '/assets/images/default/moo.png'

const CARD_CONFIG = [
  { key: 'bestTime',       title: 'Best Time To Visit',  required: true,  defaultOpen: true  },
  { key: 'cost',           title: 'Costs',               required: true,  defaultOpen: false },
  { key: 'weather',        title: 'Weather',             required: true,  defaultOpen: false },
  { key: 'transport',      title: 'Getting Around',      required: false, defaultOpen: false },
  { key: 'tips',           title: 'Tips',                required: true,  defaultOpen: false },
  { key: 'attractions',    title: 'Attractions',         required: false, defaultOpen: false },
  { key: 'culture',        title: 'Culture & Etiquette', required: false, defaultOpen: false },
  { key: 'safety',         title: 'Safety',              required: false, defaultOpen: false },
  { key: 'accessibility',  title: 'Accessibility',       required: false, defaultOpen: false }
]

export default function OverviewSection({ data, loading }) {
  const containerRef = useRef(null)
  const [columns, setColumns] = useState(1)
  const [expandedRows, setExpandedRows] = useState({})

  useEffect(() => {
    const updateColumns = () => {
      if (!containerRef.current) return
      const cols = window
        .getComputedStyle(containerRef.current)
        .getPropertyValue('grid-template-columns')
        .split(' ').length
      setColumns(cols)
    }
    updateColumns()
    window.addEventListener('resize', updateColumns)
    return () => window.removeEventListener('resize', updateColumns)
  }, [])

  useEffect(() => {
    const itemsData = CARD_CONFIG.map(conf => ({ conf }))
    const totalRows = Math.ceil(itemsData.length / columns)
    const initial = {}
    for (let row = 0; row < totalRows; row++) {
      const slice = itemsData.slice(row * columns, row * columns + columns)
      initial[row] = slice.some(({ conf }) => conf.defaultOpen)
    }
    setExpandedRows(initial)
  }, [columns])

  if (!loading && !data) return <p className="overview-error">Overview not available.</p>

  const { imageData, summary, metrics, tags = [] } = data || {}
  const itemsData = CARD_CONFIG.map(conf => {
    const items = data ? data[conf.key] || [] : []
    if (!conf.required && items.length === 0 && !loading) return null
    return { conf, items }
  }).filter(Boolean)

  return (
    <section className="overview-section">
      <ImageBlock
        imageData={imageData}
        summary={summary?.description || 'No summary available.'}
        defaultSrc={DEFAULT_IMG_URL}
        loading={loading}
      />
      <SummaryPanel metrics={metrics} tags={tags} loading={loading} />
      <div className="overview-card-grid" ref={containerRef} aria-busy={loading}>
        {itemsData.map(({ conf, items }, idx) => {
          const rowIndex = Math.floor(idx / columns)
          const isOpen = expandedRows[rowIndex]
          return (
            <Card
              key={conf.key}
              title={conf.title}
              loading={loading && items.length === 0}
              isOpen={isOpen}
              onToggle={() =>
                setExpandedRows(prev => ({
                  ...prev,
                  [rowIndex]: !prev[rowIndex]
                }))
              }
            >
              {items.length > 0 ? (
                <ul className="overview-card-list">
                  {items.map(item => (
                    <li key={item.id}>{item.description}</li>
                  ))}
                </ul>
              ) : (
                !loading && <p className="overview-card-empty">Data not available.</p>
              )}
            </Card>
          )
        })}
      </div>
    </section>
  )
}
